import { useState, type FormEvent } from "react";
import { useNavigate } from "react-router";
import { signIn, signUp, useSession } from "../lib/auth.js";
import { ErrorText, Field } from "../components/ui.js";

export function LoginPage() {
  const navigate = useNavigate();
  const { data } = useSession();
  const [mode, setMode] = useState<"signin" | "signup">("signin");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [name, setName] = useState("");
  const [error, setError] = useState<unknown>(null);
  const [busy, setBusy] = useState(false);

  if (data) {
    return (
      <section>
        <h1>ログイン済み</h1>
        <p>{data.user.email}</p>
      </section>
    );
  }

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setError(null);
    const res =
      mode === "signin"
        ? await signIn.email({ email, password })
        : await signUp.email({ email, password, name: name || email.split("@")[0] || "user" });
    setBusy(false);
    if (res.error) {
      setError(res.error.message ?? "失敗しました");
      return;
    }
    navigate("/my");
  };

  return (
    <section>
      <h1>{mode === "signin" ? "ログイン" : "新規登録"}</h1>
      <form onSubmit={submit} className="form">
        {mode === "signup" && (
          <Field label="表示名">
            <input className="input" value={name} onChange={(e) => setName(e.target.value)} autoComplete="nickname" />
          </Field>
        )}
        <Field label="メールアドレス">
          <input className="input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} autoComplete="email" />
        </Field>
        <Field label="パスワード（8文字以上）">
          <input
            className="input"
            type="password"
            required
            minLength={8}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete={mode === "signin" ? "current-password" : "new-password"}
          />
        </Field>
        <ErrorText error={error} />
        <button className="btn primary" type="submit" disabled={busy}>
          {mode === "signin" ? "ログイン" : "登録する"}
        </button>
      </form>
      <div className="row">
        <button className="btn link" type="button" onClick={() => signIn.social({ provider: "google", callbackURL: "/my" })}>
          Google でログイン
        </button>
        <button className="btn link" type="button" onClick={() => signIn.social({ provider: "apple", callbackURL: "/my" })}>
          Apple でログイン
        </button>
      </div>
      <p className="muted">
        {mode === "signin" ? (
          <>
            アカウントがない場合は{" "}
            <button className="btn link" type="button" onClick={() => setMode("signup")}>
              新規登録
            </button>
          </>
        ) : (
          <>
            すでにアカウントがある場合は{" "}
            <button className="btn link" type="button" onClick={() => setMode("signin")}>
              ログイン
            </button>
          </>
        )}
      </p>
    </section>
  );
}
